<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

        <v-col cols="12" sm="6" md="4">
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Month"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date"
              @input="menu2 = false"
              @click:month="dateSelect"
              :max="nowDate"
              type="month"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="1">
          <template>
            <v-row align="center" justify="space-around">
              <v-btn
                depressed
                color="primary"
                append-icon="mdi-printer"
                v-on:click="printList"
                >Print
              </v-btn>
            </v-row>
          </template>
        </v-col>
        <v-col cols="12" sm="6">
          <download-excel
            :data="referralData"
            worksheet="My Worksheet"
            name="referrals.xls"
          >
            <v-btn depressed color="primary" append-icon="mdi-down-arrow"
              >Download
            </v-btn>
          </download-excel>
        </v-col>
      </v-card-title>
      <v-card id="print">
        <h3>Investigation Referral Report</h3>
        <v-data-table
          :headers="headers"
          :items="referral"
          class="elevation-1"
          :search="search"
          dense
          mobile-breakpoint="0"
          disable-pagination
          :hide-default-footer="true"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
        >
          <template v-slot:no-data>
            <v-btn color="primary">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
export default {
  data() {
    return {
      search: "",
      refSl: 1,
      date: new Date().toISOString().substr(0, 7),
      nowDate: new Date().toISOString().substr(0, 7),
      menu2: false,
      doctors: [],
      doctor: null,
      loadingstatus: true,
      isLoading: true,
      headers: [
        {
          text: "SL",
          align: "start",
          value: "sno",
        },
        {
          text: "Doctor ID",
          value: "refer_doctor_id",
        },
        { text: "Doctor Name", value: "refer_doctor_name" },
        { text: "Doctor Phone", value: "refer_doctor_name_phone" },
        { text: "Invoice Amount", value: "total_sub_total" },
        { text: "Received", value: "total_paid_amount" },
        { text: "Discount Amount", value: "total_discount_amount" },
        { text: "Allow Discount", value: "allow_discount" },
        { text: "Overfllow Discount", value: "discount_overfllow" },

        { text: "Refund Amount", value: "refund_amount.total_refund_amount" },
        { text: "Referral Amount (20%)", value: "referral_amount" },
        // { text: "Payable", value: "doctor_payable" },
        { text: "Remarks", value: "" },
      ],

      referralData: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Doctor Referral Report",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {

    this.getReport();

  },
  computed: {
    referral() {
      return this.referralData.map((d, index) => ({ ...d, sno: index + 1 }));
    },
  },
  methods: {

    printList() {
      var disp_setting = "toolbar=yes,location=no,";
      disp_setting += "directories=yes,menubar=yes,";
      disp_setting += "scrollbars=yes,width=650, height=600, left=100, top=25";
      var content_vlue = document.getElementById("print").innerHTML;
      var docprint = window.open("", "", disp_setting);
      docprint.document.open();
      docprint.document.write(
        '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"'
      );
      docprint.document.write(
        '"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">'
      );
      docprint.document.write(
        '<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">'
      );
      docprint.document.write("<head><title> " + this.date + "</title>");
      docprint.document.write('<style type="text/css">body{ margin:0px;');
      docprint.document.write("font-family:verdana,Arial;color:#000;");

      docprint.document.write(
        "font-family:Verdana, Geneva, sans-serif; font-size:10px;}"
      );
      docprint.document.write(
        "table td, table th {border: 1px solid #ddd;padding: 0px; font-size:9px;}"
      );
      docprint.document.write(
        "table th, table th {padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #4CAF50;color: white;}"
      );
      docprint.document.write("table {width: 100%;}");

      docprint.document.write("a{color:#000;text-decoration:none;} </style>");
      docprint.document.write('</head><body onLoad="self.print()"><center>');
      docprint.document.write(content_vlue);
      docprint.document.write("</center></body></html>");
      docprint.document.close();
      docprint.focus();
    },
    dateSelect() {
      this.loadingstatus = true;
      this.getReport(this.doctor);
    },
    getReport() {
      atshq
        .get("referrals/investigation-referrals?month=" + this.date)
        .then((response) => {
          this.referralData = response.data.data.referral;
          this.loadingstatus = false;
          this.isLoading = false;
          console.log(this.desserts);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
  },
};
</script>